import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class EsuvoOptionService {

  constructor(private http: HttpClient) {
  }

  getFooter() {
    return this.http.get<any>('api/s/footer/info');
  }

  getOptionDto(code) {
    return this.http.get<any>('api/a/esuvo/option/' + code);
  }

  saveOption(dto) {
    return this.http.put<any>('api/a/esuvo/option/save', dto);
  }
  saveMailDto(dto) {
    return this.http.put<any>('api/a/esuvo/option/mail/save', dto);
  }

  getCommonSettings() {
    return this.http.get<any[]>('api/a/esuvo/option/common/settings');
  }

  saveCommonSettings(settings) {
    return this.http.post<any>('api/a/esuvo/option/common/settings', settings);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/esuvo-option.service.ts